import * as S from './styles'
import { useContext, useState } from 'react'
import rest from '../../rest'
import { Input } from 'semantic-ui-react'
import { StoreContext } from '../../stores/useStoreProfile'

type ChangeEvent = React.ChangeEvent<HTMLInputElement>

export default function Login() {
  const [username, setUserName] = useState("")
  const [password, setPassword] = useState("")
  const [error, setError] = useState({})
  const profile = useContext(StoreContext)
  const { api } = profile

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    const token = await rest(`token/`, 'POST', { username, password }).catch(
      err => {
        setError(err)
      }
    )
    if (token && token.access) {
      api.setToken(token.access, username)
    }
  }

  const Error = ({ message }: { message: any }) => {
    if (!message) {
      return null
    }
    if (message.detail) {
      return <S.Error>{message.detail}</S.Error>
    } else {
      return null
    }
  }
  const FieldError = ({ message, field }: { message: any, field: string }) => {
    if (!message.detail && message[field]) {
      return <S.Error>{message[field]}</S.Error>
    }
    return null
  }

  return (
    <div>
      <S.Background />
      <S.Title><p>Casa Civil</p></S.Title>
      <S.Container>
        <S.Header>Login</S.Header>
        <Error message={error} />
        <S.Form onSubmit={handleSubmit}>
          <S.Label>Usuário:</S.Label>
          <Input name="usuario" icon='user' iconPosition='left'
            onChange={(e: ChangeEvent) => setUserName(e.target.value)}
          />
          <FieldError message={error} field="username" />
          <S.Label>Senha:</S.Label>
          <Input name="senha" type="password" icon='key' iconPosition='left'
            onChange={(e: ChangeEvent) => setPassword(e.target.value)}
          />
          <FieldError message={error} field="password" />
          <S.Button name="submit" type="submit">Entrar</S.Button>
        </S.Form>
      </S.Container>
    </div>
  )
}
